import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import PagesHeader from './PagesHeader';

const HeaderWithBreadcrumbs = ({
  className = undefined,
  links,
  shouldIncludeDashboard = true,
  name,
  label,
  size = undefined,
  shouldNotDisplayHeader = false,
  headingTestId = undefined,
}) => {
  return (
    <div className="gap-y-7.5 mb-4">
      <Breadcrumbs links={links} className={className} shouldIncludeDashboard={shouldIncludeDashboard} />
      { !shouldNotDisplayHeader && (
      <div>
        <PagesHeader name={name} label={label} size={size} headingTestId={headingTestId} />
      </div>
      )}
    </div>
  );
};

HeaderWithBreadcrumbs.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  shouldIncludeDashboard: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.string,
  shouldNotDisplayHeader: PropTypes.bool,
  headingTestId: PropTypes.string,
};

export default HeaderWithBreadcrumbs;
